
/**
 *
 * @param $osmMap {jQuery}
 * @param $markerPopUps {jQuery}
 * @constructor
 */
const OpenStreetMapVO = function ($osmMap, $markerPopUps) {
    this.$osmMap = $osmMap;
    this.$markerPopUps = $markerPopUps;
    this.mapWidth = 0;
    this.mapHeight = 0;
    this.aspectRatio = "";
    /** @type {string[]} */
    this.activeIDs = null;
    this.tileLayer = '';
    this.attribution = '';
    this.hideAttribution = false;
    this.clusterClassMedium = '';
    this.clusterClassLarge = '';
    this.clusterIconWidth = 0;
    this.clusterIconHeight = 0;
    this.largeBreakpoint = 0;
    this.maxClusterRadius = 0;
    /** @type {int|null} */
    this.disableClusteringAtZoom = null;
    /** @type {int|null} */
    this.defaultZoomLevel = null;
    this.fallbackZoomLevel = 1;
    this.boundsZoomPadding = 1;
    this.centreOnUser = false;
    this.defaultCentreLatLng  = new L.LatLng(0, 0)
    this.markerIcon = {
        iconUrl: '',
        iconSize:     [0, 0],
        iconAnchor:   [0, 0],
        popupAnchor:  [0, 0]
    }
    this.userMarkerIcon = {
        iconUrl: '',
        iconSize:     [0, 0],
        iconAnchor:   [0, 0],
        popupAnchor:  [0, 0]
    }
    this.userLatLng = new L.LatLng(0, 0)
}

/**
 *
 * @constructor
 */
const OpenStreetMapFunctions = function () {
    /** @type {() => void} */
    this.onFilterApplied = null;
    /** @type {() => void} */
    this.onUserLocationChanged = null;
    /** @type {(boolean) => void} */
    this.updateMapUI = null;
}


/**
 *
 * @param $osmMap {jQuery|JQuery}
 * @param $markerPopUps {jQuery|JQuery}
 * @returns {OpenStreetMapVO}
 */
const createDefaultOpenStreetVO =  ($osmMap, $markerPopUps) =>
{

    //more styles here
    //http://leaflet-extras.github.io/leaflet-providers/preview/index.html

    const vo = new OpenStreetMapVO($osmMap, $markerPopUps);
    const defaultZoomLevel = parseInt($osmMap.data("zoom"));
    const mapWidth = parseInt($osmMap.data("map-width"));
    const mapHeight = parseInt($osmMap.data("map-height"));
    const mapAspectRatio = $osmMap.data("map-aspect-ratio");
    if(defaultZoomLevel){
        vo.defaultZoomLevel = defaultZoomLevel;
    }
    if(mapWidth){
        vo.mapWidth = mapWidth;
    }
    if(mapHeight){
        vo.mapHeight = mapHeight;
    }
    if(mapAspectRatio){
        vo.mapAspectRatio = mapAspectRatio;
    }
    vo.tileLayer = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
    //vo.tileLayer = 'http://{s}.tile.osm.org/{z}/{x}/{y}.png';
    vo.attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
    vo.hideAttribution = false;
    vo.clusterClassMedium = 'marker-cluster marker-cluster-medium';
    vo.clusterClassLarge = 'marker-cluster marker-cluster-large';
    vo.clusterIconWidth = 53;
    vo.clusterIconHeight = 53;
    vo.largeBreakpoint = 10;
    vo.maxClusterRadius = 40;
    vo.fallbackZoomLevel = 10;
    vo.recentreZoomAbove = 10;
    vo.markerIcon = {
        iconUrl: '/app/themes/hailstone/img/map/home-icon.png',
        iconSize:     [32, 32],
        iconAnchor:   [16, 32],
        popupAnchor:  [0, -32]
    }

    vo.userMarkerIcon = {
        iconUrl: '/app/themes/hailstone/img/map/user-icon.png',
        iconSize:     [32, 32],
        iconAnchor:   [16, 32],
        popupAnchor:  [0, -32]
    }

    return vo;
}

/**
 *
 * @param vo {OpenStreetMapVO}
 */
const applyExternalValues = (vo) =>
{

    let userLat = $("#user_set_lat").data("value");
    let userLng = $("#user_set_lng").data("value");

    if (!userLat)
    {
        userLat = $("#user_lat").data("value");
        userLng = $("#user_lng").data("value");
    }
    vo.userLatLng.lat = userLat ? parseFloat(userLat) : 0;
    vo.userLatLng.lng = userLng ? parseFloat(userLng) : 0;
    const $excludedMapMarkerIDs = $("#excludedMapMarkerIDs");
    vo.activeIDs = null;
    if($excludedMapMarkerIDs.length){

        const excludedIDsString = $excludedMapMarkerIDs.data("value") ?? "";
        const excludedIDs = excludedIDsString.split(",");
        vo.activeIDs = [];
        vo.$markerPopUps.each( (index, markerPopUp) => {
            const $markerPopUp = $(markerPopUp);
            const id = $markerPopUp.attr('id');
            if(!excludedIDs.includes(id)){
                vo.activeIDs.push(id);
            }

        });
    }
}


/**
 *
 * @param vo {OpenStreetMapVO}
 * @returns {OpenStreetMapFunctions}
 */
const createOpenStreetMap =  (vo) => {
    const L = window.L;

    const functions = new OpenStreetMapFunctions()
    if(!vo.$osmMap.length){
        return functions;
    }
    /** @type {L.MarkerClusterGroup} */
    let markerClusterGroup = null; // cluster
    /** @type {L.Marker[]} */
    const addedMarkers = [];

    let map = null;
    let userMarker = null;

    const initMap = () =>
    {


        if(vo.mapWidth){
            vo.$osmMap.height(vo.mapWidth);
        }
        if(vo.mapHeight){
            vo.$osmMap.addClass("defined-height");
            vo.$osmMap.height(vo.mapHeight);
        } else if(vo.mapAspectRatio){
            vo.$osmMap.css({aspectRatio: vo.mapAspectRatio});
        }

        let options = null;
        if(vo.hideAttribution){
            options = { attributionControl:false };
        }
        map = L.map(vo.$osmMap[0], options);

        L.tileLayer(vo.tileLayer, {
            attribution: vo.attribution
        }).addTo(map);
    }

    const addCluster = () =>
    {
        markerClusterGroup = L.markerClusterGroup({
            maxClusterRadius: vo.maxClusterRadius,
            disableClusteringAtZoom: vo.disableClusteringAtZoom,
            animate: false,
            iconCreateFunction: (cluster) =>
            {
                let clusterClass = vo.clusterClassMedium;
                if (cluster.getChildCount() >= vo.largeBreakpoint) {
                    clusterClass = vo.clusterClassLarge
                }
                return new L.DivIcon({
                    html: '<div><span>' + cluster.getChildCount() + '</span></div>',
                    className: clusterClass,
                    iconSize: new L.Point(vo.clusterIconWidth, vo.clusterIconHeight)
                });
            }
        });
        const markerIcon = L.icon(vo.markerIcon);

        addedMarkers.length = 0;
        vo.$markerPopUps.each( (index, markerPopUp) => {
            const $markerPopUp = $(markerPopUp);
            if($markerPopUp.data("lat") && $markerPopUp.data("lng")){
                const id = $markerPopUp.attr('id');
                const latLng = new L.LatLng(parseFloat($markerPopUp.data("lat")), parseFloat($markerPopUp.data("lng")))

                const title = $markerPopUp.data("title");
                const interactive = !!$markerPopUp.html().trim();
                const marker = L.marker(latLng, { icon: markerIcon, title: title, interactive: interactive })
                marker.info = {
                    id: id,
                    title: title
                }
                marker.bindPopup($markerPopUp[0]);
                markerClusterGroup.addLayer(marker);
                addedMarkers.push(marker);

            }
        })

        map.addLayer(markerClusterGroup);

        showActiveMarkers();
    }

    // loops through its markers and changes visibility for each to true or false
    const showActiveMarkers = () =>
    {

        for(let i = 0; i < addedMarkers.length; i ++){
            const marker = addedMarkers[i];
            const visible = !vo.activeIDs || vo.activeIDs.includes(marker.info.id);
            if(visible){
                if(!markerClusterGroup.hasLayer(marker)){
                    markerClusterGroup.addLayer(marker);
                }
            } else {
                markerClusterGroup.removeLayer(marker)
            }
        }

    }

    const showUserPosition = () =>
    {
        if(userMarker){
            map.removeLayer(userMarker);
        }
        if (!vo.userLatLng.lat || !vo.userLatLng.lng)
        {
            return
        }

        userMarker = L.marker(vo.userLatLng, { icon: L.icon(vo.userMarkerIcon)})
        map.addLayer(userMarker);
    }

    // self-explanatory, repositions map according to pins
    // but if we have a user pin, it becomes the center

    /**
     *
     * @param resetZoom {boolean?}
     */
    const centerMap = (resetZoom) =>
    {

        let target = null;
        const bounds = new L.LatLngBounds();
        let pinCount = 0;

        for(let i = 0; i < addedMarkers.length; i ++){
            bounds.extend(addedMarkers[i]._latlng)
            pinCount ++;
        }

        if(!pinCount){
            if (vo.userLatLng.lat && vo.userLatLng.lng)
            {
                if(vo.centreOnUser){
                    target = vo.userLatLng;
                }
                bounds.extend(vo.userLatLng)
                pinCount ++;
            }
        }

        if(!target){
            target = pinCount ? bounds.getCenter() : null;
        }
        let calculatedZoom = !resetZoom ? map.getZoom() : 0;
        const allowAnimations = !!calculatedZoom;

        if(calculatedZoom && vo.recentreZoomAbove && calculatedZoom > vo.recentreZoomAbove ){
            calculatedZoom = null;
        }

        if(!calculatedZoom){
            calculatedZoom = vo.defaultZoomLevel;
        }

        if(!calculatedZoom && pinCount < 2){
            calculatedZoom = vo.fallbackZoomLevel;
        }

        const latLng = vo.defaultCentreLatLng.lat && vo.defaultCentreLatLng.lng ? vo.defaultCentreLatLng : target;

        if(latLng){
            map.setView(latLng, calculatedZoom);
        }

        if(!calculatedZoom){
            map.fitBounds(bounds, {animate: allowAnimations});
            map.setZoom(map.getZoom() - vo.boundsZoomPadding, {animate: allowAnimations})
        }

    }


    initMap();
    addCluster();
    centerMap();
    showUserPosition();

    functions.onFilterApplied =  () =>
    {
        showActiveMarkers();
    }
    functions.onUserLocationChanged =  () => 
    {
        showUserPosition();
        centerMap();
    }

    functions.updateMapUI =  (doCenterMap) =>
    {
        applyExternalValues(vo);
        map.invalidateSize();
        showActiveMarkers();
        showUserPosition();
        if(doCenterMap || map.getZoom() === 0){
            centerMap(doCenterMap);
        }
    }
    return functions;
}


/**
 *
 * @param lat {float}
 * @param lng {float}
 * @param callback {({city:string, town:string, village:string, region:string, state:string, county:string, postcode:string, countryCode:string, country:string}) => void}
 */
const osmSearchLatLng = (lat, lng, callback) =>
{
    $.get('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat='+lat+'&lon='+lng, (data) =>
    {
        const address = data ? data.address : null;
        callback(address);
    }).fail(function() {
        callback(null);
    });
}

/**
 *
 * @param searchValue {string}
 * @param callback {({lat: float, lng: float, display_name: string, address: {city:string, town:string, village:string, region:string, state:string, county:string, postcode:string, country_code:string, country:string}}) => void}
 * @param requirements {{state:string, country_code:string}=}
 */
const osmSearchTownPostcode =  (searchValue, callback, requirements) =>
{
    searchValue = searchValue ? searchValue.trim() : null;
    if(!searchValue){
        callback(null);
        return;
    }
    requirements = requirements ? requirements : {};
    for(const key in requirements){
        requirements[key] = Array.isArray(requirements[key]) ? requirements[key] : [requirements[key]];
        for(let i = 0; i < requirements[key].length; i ++){
            requirements[key][i] = requirements[key][i].toLowerCase();
        }

    }

    const countryCodeRequirements = requirements.hasOwnProperty('country_code') ? (requirements.country_code ? requirements.country_code : []) : ['gb', 'ie'];
    const stateRequirements = requirements.state ? requirements.state : [];

    const callSearch = (params, searchCallback) =>
    {
        let query = 'format=jsonv2&addressdetails=1'
        for(const key in params){
            query += '&'+key+'='+encodeURIComponent(params[key].toLowerCase());
        }
        $.get('https://nominatim.openstreetmap.org/search?'+query, (data) =>
        {

            if(data){
                for(let i = 0; i < data.length; i ++){
                    const item = data[i];
                    const address = item.address;
                    if((!countryCodeRequirements.length || countryCodeRequirements.includes(address.country_code.toLowerCase())) && (!stateRequirements.length || stateRequirements.includes(address.state.toLowerCase()))){
                        callback(item);
                        return null;
                    }
                }
            }
            searchCallback(null);
        }).fail(() => {
            searchCallback(null)
        });
    }


    const searchBasicPostcode = () => {
        const noSpace = searchValue.split(" ")[0];
        if(!noSpace || noSpace === searchValue){
            callback(null)
            return;
        }
        callSearch({
            q: noSpace
        },  (response) => {
            callback(response)
        })
    }

    const searchPostcode = () => {
        callSearch({
            q: searchValue
        },  (response) => {
            if (response) {
                callback(response)
                return;
            }
            searchBasicPostcode();
        });
    }

    /**
     *
     * @param countryCodeIndex {int}
     */
    const searchCity = (countryCodeIndex) => {
        if(countryCodeIndex === countryCodeRequirements.length){
            searchPostcode();
            return;
        }
        const country = countryCodeRequirements[countryCodeIndex];
        callSearch({
            country: country,
            city: searchValue
        },  (response) =>
        {
            if(response){
                callback(response)
                return;
            }
            searchCity(countryCodeIndex + 1);
        });
    }

    searchCity(0);
}